/* MOEBE GARAN block: hover does not steal focus or lock scrolling. Click pins a modal. */
(() => {
  'use strict';
  if (!window.customElements || customElements.get('moebe-garan-badge')) return;
  class MoebeGaranBadge extends HTMLElement {
    connectedCallback() { queueMicrotask(() => { if (this.isConnected) this.init(); }); }
    init() {
      if (this.events) return;
      this.trigger = this.querySelector('[data-garan-open]');
      this.panel = this.querySelector('dialog');
      if (!this.trigger || !this.panel || typeof this.panel.showModal !== 'function') return;
      this.events = new AbortController();
      this.mode = null;
      const opt = {signal:this.events.signal};
      const on = (el, type, fn) => el.addEventListener(type, fn, opt);
      this.hoverMedia = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 769px)');
      on(this.trigger, 'click', e => {
        if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button) return;
        e.preventDefault(); this.openModal();
      });
      on(this.trigger, 'keydown', e => { if (e.key === ' ') {e.preventDefault();this.openModal();} });
      on(this.trigger, 'pointerenter', e => {
        clearTimeout(this.closeTimer);
        if (this.dataset.hover !== 'true' || !this.hoverMedia.matches || e.pointerType !== 'mouse') return;
        clearTimeout(this.openTimer);
        this.openTimer = setTimeout(() => this.openHover(), 140);
      });
      on(this.trigger, 'pointerleave', () => {clearTimeout(this.openTimer);this.scheduleClose();});
      on(this.panel, 'pointerenter', () => clearTimeout(this.closeTimer));
      on(this.panel, 'pointerleave', () => this.scheduleClose());
      on(this.panel, 'focusin', () => clearTimeout(this.closeTimer));
      on(this.panel, 'focusout', () => this.scheduleClose());
      on(this.panel.querySelector('[data-garan-close]'), 'click', () => this.close(true));
      on(this.panel, 'cancel', e => {e.preventDefault();this.close(true);});
      on(this.panel, 'close', () => {if (this.mode === 'modal' && !this.panel.open) this.cleanup(true);});
      on(document, 'keydown', e => {
        if (!this.mode) return;
        if (e.key === 'Escape') {e.preventDefault();e.stopPropagation();this.close(true);}
        if (e.key === 'Tab' && this.mode === 'modal') this.trap(e);
      });
      on(document, 'pointerdown', e => {
        if (this.mode === 'hover' && !this.panel.contains(e.target) && !this.trigger.contains(e.target)) this.close(false);
      });
      const outside = e => {const r=this.panel.getBoundingClientRect();return e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom;};
      on(this.panel, 'pointerdown', e => {this.backdropStart=outside(e);});
      on(this.panel, 'click', e => {
        if (this.mode==='modal' && this.backdropStart && e.target===this.panel && outside(e)) this.close(true);
        this.backdropStart=false;
      });
      on(this.panel.querySelector('[data-garan-zoom]'), 'click', () => {
        if (this.mode==='hover') {this.openModal();return;}
        const art=this.panel.querySelector('[data-garan-artwork]');
        const zoom=this.panel.querySelector('[data-garan-zoom]');
        const enlarged=art.classList.toggle('is-enlarged');
        zoom.setAttribute('aria-pressed',String(enlarged));zoom.textContent=enlarged?zoom.dataset.fit:zoom.dataset.enlarge;
      });
      on(this.panel.querySelector('[data-garan-image]'), 'error', () => {this.panel.querySelector('[data-garan-error]').hidden=false;});
      on(window, 'resize', () => {if(this.mode==='hover')this.close(false);});
      window.addEventListener('scroll', () => {if(this.mode==='hover')this.placeHover();}, {signal:this.events.signal,passive:true});
    }
    prepare() {
      const previous=MoebeGaranBadge.active;
      if(previous && previous!==this) previous.close(false);
      MoebeGaranBadge.active=this;
      if(this.panel.parentElement!==document.body) document.body.append(this.panel);
      const image=this.panel.querySelector('[data-garan-image]');
      if(!image.getAttribute('src')) image.src=image.dataset.src;
      this.trigger.setAttribute('aria-expanded','true');
    }
    openHover() {
      if(this.mode || !this.isConnected || !this.hoverMedia.matches || !this.trigger.matches(':hover') || document.querySelector('dialog:modal'))return;
      this.prepare();this.mode='hover';this.panel.dataset.mode='hover';
      this.panel.setAttribute('aria-modal','false');
      this.panel.setAttribute('open',''); // Nonmodal display without browser autofocus.
      this.panel.querySelector('[data-garan-body]').scrollTop=0;
      this.placeHover();
    }
    placeHover() {
      const r=this.trigger.getBoundingClientRect(),v=window.innerWidth,h=window.innerHeight;
      if(r.bottom<0||r.top>h){this.close(false);return;}
      const width=this.panel.getBoundingClientRect().width;
      const height=this.panel.getBoundingClientRect().height;
      let left=r.left-width-10;
      if(left<12) left=r.right+10;
      if(left+width>v-12) left=Math.max(12,Math.min(r.left,v-width-12));
      this.panel.style.left=`${left}px`;
      this.panel.style.top=`${Math.max(12,Math.min(r.top,h-height-12))}px`;
    }
    scheduleClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer=setTimeout(() => {
        if(this.mode==='hover' && !this.trigger.matches(':hover') && !this.panel.matches(':hover') && !this.panel.contains(document.activeElement))this.close(false);
      },400);
    }
    openModal() {
      clearTimeout(this.openTimer);clearTimeout(this.closeTimer);
      if(this.mode==='modal')return;
      if(this.mode==='hover') this.panel.removeAttribute('open');
      this.prepare();this.panel.dataset.mode='modal';this.panel.style.left='';this.panel.style.top='';
      this.panel.setAttribute('aria-modal','true');this.mode='modal';
      const style=document.body.style,names=['position','top','left','width','overflow','padding-right','box-sizing'];
      this.state={x:scrollX,y:scrollY,props:names.map(n=>[n,style.getPropertyValue(n),style.getPropertyPriority(n)])};
      const gap=Math.max(0,innerWidth-document.documentElement.clientWidth),pad=parseFloat(getComputedStyle(document.body).paddingRight)||0;
      for(const [k,v] of Object.entries({position:'fixed',top:`${-this.state.y}px`,left:`${-this.state.x}px`,width:'100%',overflow:'hidden','padding-right':`${pad+gap}px`,'box-sizing':'border-box'}))style.setProperty(k,v);
      try {
        this.panel.showModal();this.panel.querySelector('[data-garan-body]').scrollTop=0;
        this.panel.querySelector('[data-garan-close]').focus({preventScroll:true});
      } catch(error) {this.cleanup(true);console.warn('MOEBE: could not open guarantee label.',error);}
    }
    trap(e) {
      const stops=[...this.panel.querySelectorAll('button,a[href],[tabindex="0"]')].filter(el=>el.getClientRects().length&&!el.disabled);
      const first=stops[0],last=stops[stops.length-1];
      if(!first)return;
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    }
    close(returnFocus) {
      clearTimeout(this.openTimer);clearTimeout(this.closeTimer);
      if(!this.mode)return;
      if(this.mode==='modal' && this.panel.open)this.panel.close();else this.panel.removeAttribute('open');
      this.cleanup(returnFocus);
    }
    cleanup(returnFocus) {
      const wasModal=this.mode==='modal',hadFocus=this.panel.contains(document.activeElement);
      this.mode=null;this.trigger.setAttribute('aria-expanded','false');
      this.panel.removeAttribute('open');delete this.panel.dataset.mode;
      const state=this.state;this.state=null;
      if(state){
        for(const [n,v,p] of state.props){if(v)document.body.style.setProperty(n,v,p);else document.body.style.removeProperty(n);}
        const root=document.documentElement.style,old=root.getPropertyValue('scroll-behavior'),priority=root.getPropertyPriority('scroll-behavior');
        root.setProperty('scroll-behavior','auto','important');window.scrollTo(state.x,state.y);
        if(old)root.setProperty('scroll-behavior',old,priority);else root.removeProperty('scroll-behavior');
      }
      const art=this.panel.querySelector('[data-garan-artwork]'),zoom=this.panel.querySelector('[data-garan-zoom]');
      art.classList.remove('is-enlarged');zoom.setAttribute('aria-pressed','false');zoom.textContent=zoom.dataset.enlarge;
      if(returnFocus&&(wasModal||hadFocus)&&this.trigger.isConnected)this.trigger.focus({preventScroll:true});
      if(MoebeGaranBadge.active===this)MoebeGaranBadge.active=null;
    }
    disconnectedCallback() {
      clearTimeout(this.openTimer);clearTimeout(this.closeTimer);
      if(!this.events)return;
      this.close(false);this.events.abort();this.events=null;
      if(this.panel.parentElement===document.body){this.panel.remove();this.append(this.panel);}
    }
  }
  customElements.define('moebe-garan-badge',MoebeGaranBadge);
})();
